const _jsxFileName = '';
import React, { useEffect, useState } from 'react';
import { ArrowRight } from 'lucide-react';

const Hero = ({ onNavigate, user }) => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setLoaded(true);
  }, []);

  return React.createElement(
    'section',
    {
      className: 'relative w-full h-screen overflow-hidden flex items-center justify-center',
      __self: this,
      __source: { fileName: _jsxFileName, lineNumber: 18 },
    },
    /* Background Image with Overlay */
    React.createElement(
      'div',
      {
        className: 'absolute inset-0 z-0',
        __self: this,
        __source: { fileName: _jsxFileName, lineNumber: 20 },
      },
      /* Updated Background Photo - Soft Luxury Interior/Texture */
      React.createElement('img', {
        src: 'https://images.unsplash.com/photo-1586023492125-27b2c045efd7?q=80&w=2158&auto=format&fit=crop',
        alt: 'Luxury Environment Background',
        className: 'w-full h-full object-cover opacity-100',
        __self: this,
        __source: { fileName: _jsxFileName, lineNumber: 22 },
      }),
      /* Increased white overlays for a very light, airy feel */
      React.createElement('div', {
        className: 'absolute inset-0 bg-stone-50/60 mix-blend-overlay z-10',
        __self: this,
        __source: { fileName: _jsxFileName, lineNumber: 28 },
      }),
      React.createElement('div', {
        className:
          'absolute inset-0 bg-gradient-to-b from-white/80 via-white/60 to-stone-50/95 z-10',
        __self: this,
        __source: { fileName: _jsxFileName, lineNumber: 29 },
      })
    ),

    /* Floating Overlay Photo - Desktop Only - PRESERVED */
    React.createElement(
      'div',
      {
        className: `absolute right-[12%] bottom-[15%] z-20 hidden xl:block transition-all duration-1000 delay-500 transform ${loaded ? 'translate-y-0 opacity-100' : 'translate-y-20 opacity-0'}`,
        __self: this,
        __source: { fileName: _jsxFileName, lineNumber: 33 },
      },
      React.createElement(
        'div',
        {
          className:
            'relative w-72 aspect-[3/4] shadow-2xl p-3 bg-white/40 backdrop-blur-md border border-white/60 rotate-6 hover:rotate-0 transition-transform duration-700 ease-out cursor-pointer group',
          __self: this,
          __source: { fileName: _jsxFileName, lineNumber: 34 },
        },
        React.createElement('img', {
          src: 'https://images.unsplash.com/photo-1603561591411-07134e71a2a9?q=80&w=2000&auto=format&fit=crop',
          alt: 'Diamond Ring Feature',
          className: 'w-full h-full object-cover',
          __self: this,
          __source: { fileName: _jsxFileName, lineNumber: 35 },
        }),
        /* Gloss shine effect on hover */
        React.createElement('div', {
          className:
            'absolute inset-0 bg-gradient-to-tr from-white/0 via-white/0 to-white/30 opacity-0 group-hover:opacity-100 transition-opacity duration-500',
          __self: this,
          __source: { fileName: _jsxFileName, lineNumber: 41 },
        }),

        /* Badge */
        React.createElement(
          'div',
          {
            className:
              'absolute -left-5 -bottom-5 w-20 h-20 bg-stone-50 rounded-full flex items-center justify-center shadow-lg border border-stone-200 group-hover:scale-110 transition-transform duration-300',
            __self: this,
            __source: { fileName: _jsxFileName, lineNumber: 44 },
          },
          React.createElement(
            'span',
            {
              className:
                'text-[9px] uppercase tracking-widest text-center font-serif leading-3 text-stone-800',
              __self: this,
              __source: { fileName: _jsxFileName, lineNumber: 45 },
            },
            'Featured',
            React.createElement('br', {
              __self: this,
              __source: { fileName: _jsxFileName, lineNumber: 46 },
            }),
            'Edit'
          )
        )
      )
    ),

    /* Content */
    React.createElement(
      'div',
      {
        className: `relative z-20 text-center px-4 max-w-4xl mx-auto transition-all duration-1000 transform ${loaded ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`,
        __self: this,
        __source: { fileName: _jsxFileName, lineNumber: 53 },
      },
      React.createElement(
        'p',
        {
          className:
            'text-gold-600 text-xs md:text-sm tracking-[0.3em] uppercase mb-6 animate-fade-in font-semibold drop-shadow-sm',
          __self: this,
          __source: { fileName: _jsxFileName, lineNumber: 54 },
        },
        'Sparkling Gems • Philippines'
      ),
      React.createElement(
        'h1',
        {
          className:
            'font-serif text-5xl md:text-7xl lg:text-8xl text-stone-900 mb-8 leading-tight drop-shadow-md',
          __self: this,
          __source: { fileName: _jsxFileName, lineNumber: 57 },
        },
        'Curated Luxury, ',
        React.createElement('br', {
          __self: this,
          __source: { fileName: _jsxFileName, lineNumber: 58 },
        }),
        React.createElement(
          'span',
          {
            className: 'italic text-gold-600',
            __self: this,
            __source: { fileName: _jsxFileName, lineNumber: 59 },
          },
          'Authenticated'
        )
      ),
      React.createElement(
        'p',
        {
          className:
            'text-stone-900 text-sm md:text-base font-normal tracking-wide max-w-xl mx-auto mb-10 leading-relaxed bg-white/40 backdrop-blur-md p-6 rounded-sm shadow-sm border border-white/40',
          __self: this,
          __source: { fileName: _jsxFileName, lineNumber: 61 },
        },
        'Handpicked bags, jewelry, and fragrances with premium presentation and exclusive member perks. Experience the pinnacle of elegance.'
      ),

      React.createElement(
        'div',
        {
          className: 'flex flex-col md:flex-row gap-6 justify-center items-center',
          __self: this,
          __source: { fileName: _jsxFileName, lineNumber: 65 },
        },
        React.createElement(
          'button',
          {
            onClick: () => onNavigate('shop'),
            className:
              'group relative px-8 py-4 bg-gold-600 text-white overflow-hidden transition-all hover:bg-gold-500 w-48 shadow-lg shadow-gold-200',
            __self: this,
            __source: { fileName: _jsxFileName, lineNumber: 66 },
          },

          React.createElement('div', {
            className:
              'absolute inset-0 w-0 bg-white/20 transition-all duration-[250ms] ease-out group-hover:w-full',
            __self: this,
            __source: { fileName: _jsxFileName, lineNumber: 70 },
          }),
          React.createElement(
            'span',
            {
              className:
                'relative z-10 flex items-center justify-center gap-2 text-xs tracking-[0.2em] uppercase',
              __self: this,
              __source: { fileName: _jsxFileName, lineNumber: 71 },
            },
            'Browse Shop ',
            React.createElement(ArrowRight, {
              size: 14,
              __self: this,
              __source: { fileName: _jsxFileName, lineNumber: 72 },
            })
          )
        ),

        !user &&
          React.createElement(
            'button',
            {
              onClick: () => onNavigate('auth'),
              className:
                'px-8 py-4 border border-stone-800 text-stone-900 hover:border-stone-900 hover:bg-stone-900 hover:text-white transition-all w-48 bg-white/40 backdrop-blur-sm shadow-sm',
              __self: this,
              __source: { fileName: _jsxFileName, lineNumber: 77 },
            },

            React.createElement(
              'span',
              {
                className: 'text-xs tracking-[0.2em] uppercase font-bold',
                __self: this,
                __source: { fileName: _jsxFileName, lineNumber: 81 },
              },
              'Member Login'
            )
          )
      )
    ),

    /* Scroll Indicator */
    React.createElement(
      'div',
      {
        className:
          'absolute bottom-10 left-1/2 -translate-x-1/2 z-20 animate-bounce text-stone-800',
        __self: this,
        __source: { fileName: _jsxFileName, lineNumber: 88 },
      },
      React.createElement(
        'span',
        {
          className: 'text-[10px] tracking-widest uppercase mb-2 block font-semibold',
          __self: this,
          __source: { fileName: _jsxFileName, lineNumber: 89 },
        },
        'Scroll'
      ),
      React.createElement('div', {
        className: 'w-[1px] h-12 bg-gradient-to-b from-stone-800 to-transparent mx-auto',
        __self: this,
        __source: { fileName: _jsxFileName, lineNumber: 90 },
      })
    )
  );
};

export default Hero;
